/* eslint-disable */
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { Link } from 'react-router';

import * as mensagemActions from './actions/mensagemActions'
import ConfigD from './util/ConfigD'
import './css/loginForm.css'
import './css/step.css'
import 'jquery-validation';
import $ from 'jquery';
import Alert from 'react-s-alert';
import './css/consultarProtocolo.css'

class AutenticarForm extends React.Component {
 
    constructor(props, context) {
        super(props, context);
        //debugger;
        this.state = {
            erro:''
        };
        this.logar = this.logar.bind(this);
    }


    logar(event){
        if (event != undefined) {
            event.preventDefault();
            event.stopPropagation();
        }

        if ($('#consultar-form').valid()) {
           //console.log(this.props.token)

            var codigo = $('#codigoLogin').val();

            var data = {
                codigo: codigo,
                token: this.props.token
            }
           //console.log('data - ', data);
            this.props.actions.Validar(data).catch(error => {
                //debugger;
                if(error===null){
                    this.setState({erro: 'Código inválido'})
                    $('.alert-danger', $('#consultar-form')).show();
                }else{
                    Alert.warning(!$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText, {
                        position: 'top-right',
                        effect: 'slide',
                        offset: 172,
                        timeout: 5000
                    });
                }
            });;
        }
    }

    componentDidMount() {
        //debugger;
        //this.props.actionCliente.validarCliente(null);
        $("#formCodigo").show();
        $("#validado").hide();
        $('.alert-danger', $('#consultar-form')).hide();
        $('#consultar-form').validate({
            errorElement: 'span',
            errorClass: 'help-block',
            focusInvalid: false,
            rules: {
                codigoLogin: {
                    required: true
                }
            },

            messages: {
                codigoLogin: {
                    required: "Senha necessária."
                }
            },

            invalidHandler: function (event, validator) {
                //$('.alert-danger', $('#consultar-form')).show();
            },

            highlight: function (element) {
                $(element)
                    .closest('.form-group').addClass('has-error');
            },

            success: function (label) {
                label.closest('.form-group').removeClass('has-error');
                label.remove();
            },

            errorPlacement: function (error, element) {
                error.insertAfter(element.closest('.input-icon'));
            }
        });

    }
    
    componentWillReceiveProps(nextProps) {
        //debugger;
        if (!$.isEmptyObject(nextProps.mensagem) && this.props.mensagem !== nextProps.mensagem) {
            Alert.success('Titularidade confirmada!', {
                position: 'top-right',
                effect: 'slide',
                offset: 172,
                timeout: 15000
            });
            $("#formCodigo").hide();
            $("#validado").show();
            //this.context.router.push(ConfigD.getServerBase() + '/consultarProtocolo');
        }
    }

    render() {
        //console.log('servicos', this.props.servicos);
        // if($.isEmptyObject(this.props.servicos)){
        //   return <div/>
        // }
        //console.log('this.props.servicoCalculado ' , this.state.servicoSelecionado)

    return (

        <div>
            <form method="post" id='consultar-form' >
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" id="formCodigo" style={{display: ''}}>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <h3 className="title">Informe o código enviado por e-mail ou celular para autenticar:</h3>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">

                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div className="alert alert-danger display-hide">
                                    <button className="close" data-close="alert"></button>
                                    <span tabIndex="0"> {this.state.erro} </span>
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div className="form-group">
                                    <div className="input-icon">
                                        <label><b>Código:</b></label>
                                        <input type="text" className="form-control" placeholder="Código" name="codigoLogin" id='codigoLogin' />
                                        <Link to={ConfigD.getServerBase() + '/recuperarProtocolo'} className='linkRecuperarProtocolo'>Solicitar novo código</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <button type="submit" onClick={this.logar}>Validar</button>
                            </div>
                        </div>
                        
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12" id="validado"  style={{display: 'none', minHeight:'200px'}}>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <label style={{color:'#2e66b7'}}><b>Titularidade validada! </b> Obrigado!</label>
                            </div>
                        </div>
                </div>

            </form>
        </div>
    );
  }
}

AutenticarForm.protoType = {
    //actionCliente: PropTypes.object.isRequired
}
AutenticarForm.contextTypes = {
  router: React.PropTypes.object
};

function mapStateToProps(state, ownProps){
    //debugger;
    return {
        mensagem: state.mensagem,
        urlNavegacao: state.urlNavegacao
    };
}

function mapDispatchToProps(dispatch){
   return {
        
       actions: bindActionCreators(mensagemActions, dispatch)
    };
    
}

export default connect(mapStateToProps, mapDispatchToProps)(AutenticarForm);



/** WEBPACK FOOTER **
 ** ./src/components/AutenticarForm.js
 **/